import React from 'react';
import {connect} from 'react-redux';
import {Row, Col, Table, Button, Badge, Nav, NavItem, NavLink, TabContent, TabPane,
        Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter,
        InputGroup, InputGroupAddon} from 'reactstrap';
import {push} from 'react-router-redux';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import {get, post} from './Api';
import {Calculator} from './CalculatorTransfer';
import {LOGOUT} from './Login';
import {load_users} from './Users';
import plural from './plural';
import {date_from_string, iso_date_string, format_price, month_names} from './utils.js';
import {DONE_FILTER, filter_by_done, base_transfer_date, date_in_optional_inclusive_range,
        transfer_result_in_period, filter_by_debt, DEBT_FILTER, transfer_validation_errors,
        transfer_debt, when_transfer_may_be_paid, transfer_result_if_paid_today, is_complete_transfer,
        transfer_debt_days, is_cash_sell_transfer, transfer_has_files} from './transfers-math';
import {BaseField, TextInput} from './form-controls';
import {Page} from './Page';


const LOADING_TRANSFERS = 'LOADING_TRANSFERS';
const LOAD_TRANSFERS__OK = 'LOAD_TRANSFERS__OK';
const LOAD_TRANSFERS__FAIL = 'LOAD_TRANSFERS__FAIL';

const SAVING_TRANSFER = 'SAVING_TRANSFER';
const SAVING_TRANSFER__OK = 'SAVING_TRANSFER__OK';
const SAVING_TRANSFER__FAIL = 'SAVING_TRANSFER__FAIL';

const SAVING_NEW_TRANSFER = 'SAVING_NEW_TRANSFER';
const SAVING_NEW_TRANSFER__OK = 'SAVING_NEW_TRANSFER__OK';
const SAVING_NEW_TRANSFER__FAIL = 'SAVING_NEW_TRANSFER__FAIL';

const DELETE_TRANSFER = 'DELETE_TRANSFER';

const LOADING_ALL_TRANSFERS = 'LOADING_ALL_TRANSFERS';
const LOAD_ALL_TRANSFERS__OK = 'LOAD_ALL_TRANSFERS__OK';
const LOAD_ALL_TRANSFERS__FAIL = 'LOAD_ALL_TRANSFERS__FAIL';


const load_transfers = (user_id) => async (dispatch) => {
    dispatch({type: LOADING_TRANSFERS, user_id});
    try {
        const response = await get('transfers', {user_id});
        dispatch({type: LOAD_TRANSFERS__OK, user_id, transfers: response});
    }
    catch (failure) {
        dispatch({type: LOAD_TRANSFERS__FAIL, user_id, loading_failure: failure});
    }
};

const load_all_transfers = (done_filter, date_from, date_to) => async (dispatch) => {
    dispatch({type: LOADING_ALL_TRANSFERS, date_from, date_to});
    try {
        const response = await get('all-transfers', {
            done_filter: done_filter,
            date_from: [DONE_FILTER.ALL, DONE_FILTER.DONE].indexOf(done_filter) != -1 ? iso_date_string(date_from) : null,
            date_to: [DONE_FILTER.ALL, DONE_FILTER.DONE].indexOf(done_filter) != -1 ? iso_date_string(date_to) : null,
        });
        dispatch({
            type: LOAD_ALL_TRANSFERS__OK,
            done_filter,
            date_from, date_to,
            transfers: response.transfers,
            usernames: response.usernames
        });
    }
    catch (failure) {
        dispatch({type: LOAD_ALL_TRANSFERS__FAIL, loading_failure: failure});
    }
};

const save_transfer = (user_id, transfer_id, params, ok_url) => async (dispatch) => {
    dispatch({type: SAVING_TRANSFER, user_id});
    try {
        const response = await post('save-transfer', {
            user_id, transfer_id,
            params: {
                ...params,
                last_date: iso_date_string(base_transfer_date(params)),
                penalty_date: iso_date_string(date_from_string(params.penalty_date))
            },
            debt: transfer_debt(params)
        });
        dispatch({type: SAVING_TRANSFER__OK, user_id, transfer_id, params});
        dispatch(push(ok_url));
    }
    catch (failure) {
        console.log(failure);
        dispatch({type: SAVING_TRANSFER__FAIL, user_id, failure});
    }
};

const save_new_transfer = (user_id, params, ok_url) => async (dispatch) => {
    dispatch({type: SAVING_NEW_TRANSFER, user_id});
    try {
        const response = await post('save-new-transfer', {
            user_id, 
            params: {
                ...params,
                last_date: iso_date_string(base_transfer_date(params)),
                penalty_date: iso_date_string(date_from_string(params.penalty_date))
            },
            debt: transfer_debt(params)
        });
        dispatch({
            type: SAVING_NEW_TRANSFER__OK,
            user_id,
            transfer_id: response.id,
            params: response.params
        });
        dispatch(push(ok_url));
    }
    catch (failure) {
        console.log(failure);
        dispatch({type: SAVING_NEW_TRANSFER__FAIL, user_id, failure});
    }
};

const delete_transfer = (user_id, transfer_id) => (dispatch) => {
    if (confirm('Действительно удалить запись о перевозке?')) {
        post('delete-transfer', {user_id, id: transfer_id});
        dispatch({type: DELETE_TRANSFER, user_id, transfer_id});
    }
};


const by_user_initial = {
    loaded: false,
    loading: false,
    fail: false,

    transfers: [],

    saving_transfer: false,
    saving_transfer_fail: false,

    saving_new_transfer: false,
    saving_new_transfer_fail: false,
};


const sort_transfers = (transfers) => transfers.slice().sort((d1, d2) => d1.params.date > d2.params.date);

const user_reducer = (state = by_user_initial, action) => {
    switch (action.type) {
        case LOADING_TRANSFERS: return {...state, loading: true, fail: false};
        case LOAD_TRANSFERS__OK: return {...state, loading: false, loaded: true, fail: false, transfers: action.transfers};
        case LOAD_TRANSFERS__FAIL: return {...state, loading: false, loaded: true, fail: true, transfers: []};

        case SAVING_TRANSFER: return {...state, saving_transfer: true, saving_transfer_fail: false};
        case SAVING_TRANSFER__OK: return {
            ...state,
            saving_transfer: false,
            saving_transfer_fail: false,
            transfers: sort_transfers(state.transfers.map(transfer => transfer.id == action.transfer_id ? {...transfer, params: action.params} : transfer))
        };
        case SAVING_TRANSFER__FAIL: return {...state, saving_transfer: false, saving_transfer_fail: true};

        case SAVING_NEW_TRANSFER: return {...state, saving_new_transfer: true, saving_new_transfer_fail: false};
        case SAVING_NEW_TRANSFER__OK:
            return {
                ...state,
                saving_new_transfer: false,
                saving_new_transfer_fail: false,
                transfers: sort_transfers([
                    ...state.transfers,
                    {id: action.transfer_id, params: action.params}
                ])
            };
        case SAVING_NEW_TRANSFER__FAIL: return {...state, saving_new_transfer: false, saving_new_transfer_fail: true};

        case DELETE_TRANSFER: return {
            ...state,
            transfers: state.transfers.filter(transfer => transfer.id != action.transfer_id)
        }

        case LOGOUT: return by_user_initial;

        default: return state;
    }
};


const all_transfers_initial = {
    loaded: false,
    loading: false,
    fail: false,

    date_from: null,
    date_to: null,
    transfers: [],
    usernames: {}
};

const all_transfers_reducer = (state = all_transfers_initial, action) => {
    switch (action.type) {
        case LOADING_ALL_TRANSFERS: return {
            ...state,
            loading: true, fail: false,
            date_from: action.date_from, date_to: action.date_to
        };
        case LOAD_ALL_TRANSFERS__OK: return {
            ...state,
            loading: false, loaded: true, fail: null,
            date_from: action.date_from,
            date_to: action.date_to,
            transfers: action.transfers,
            usernames: action.usernames
        };
        case LOAD_ALL_TRANSFERS__FAIL: return {
            ...state,
            loading: false, loaded: true,
            fail: action.loading_failure
        };
        default: return state;
    }
};


const initial = {
    by_user: by_user_initial,
    all_transfers: all_transfers_initial
}

export const reducer = (state = initial, action) => {
    if (action.user_id != null) {
        return {
            ...state,
            by_user: {
                ...state.by_user,
                [action.user_id]: user_reducer(state.by_user[action.user_id], action)
            }
        }
    }
    else
        return {
            ...state,
            all_transfers: all_transfers_reducer(state.all_transfers, action)
        };
};


const cmp_transfers_by_date = (a, b) => {
    if (! a.params.date) return -1;
    if (! b.params.date) return +1;
    return date_from_string(b.params.date).getTime() - date_from_string(a.params.date).getTime();
};


const TransfersListImpl = ({transfers, role, period_start, period_end, view_href, edit_href, firstHeader, firstCell, onDeleteTransfer, onPushUrl}) => {
    const now = new Date();
    const rows = transfers.slice().sort(cmp_transfers_by_date).map(transfer => {
        let debt_days_element;
		
        const debt_days = transfer_debt_days(transfer);
        if (debt_days == null)
            debt_days_element = null;
        else if (debt_days < 0)
            debt_days_element = <span className='text-success' title='Количество дней до оплаты'>({-debt_days} дн) </span>;
        else
            debt_days_element = <span className='text-danger' title='Количество дней просрочки'>({debt_days} дн) </span>;

        return <tr key={transfer.id}
                   onClick={(ev) => {
                       // FIXME: too hacky :(
                       if (ev.target.tagName != 'A' && (ev.target.parentElement && ev.target.parentElement.tagName) != 'A')
                           onPushUrl(edit_href(transfer.user_id, transfer.id))}
                    }
                   style={{
                       cursor: 'pointer',
                       backgroundColor: transfer.params.exclude_from_ranktable ? '#e0e0e0' : null
                    }}>
            {firstCell && firstCell(transfer)}
            <td>{transfer.params && transfer.params.date && date_from_string(transfer.params.date).toLocaleDateString()}</td>
            <td className='text-right' style={{width: '100px', whiteSpace: 'nowrap'}}>
                {/* {format_price(transfer_result_in_period(transfer.params, period_start, period_end))} */}
                {format_price(
                    is_complete_transfer(transfer)
                    ? transfer_result_in_period(transfer.params, period_start, period_end)
                    : transfer_result_if_paid_today(transfer.params)
                )}
            </td>
            <td>
                {transfer.params.status == 'paid' &&
                    <Badge color='' className='border border-success text-success' title='Оплачено'>
                        <span className='oi oi-check'/>
                    </Badge>
                }
            </td>
            <td>
                {transfer.params.locked &&
                    <Badge color='' className='border border-info text-info' title='Проверено'>
                        <span className='oi oi-lock-locked'/>
                    </Badge>
                }
            </td>
            <td>{transfer_has_files(transfer.params) &&
                    <Badge color='' className='border border-primary text-primary' title='Сканы'>
                        <span className='oi oi-file'/>
                    </Badge>}
            </td>
            <td>{transfer.params && transfer.params.title}</td>
            <td>{transfer.params && transfer.params.basis}</td>
            <td>{transfer.params && transfer.params.fuel_type}</td>
            <td>{transfer.params && transfer.params.ttn_number}</td>
            <td width='1' style={{whiteSpace: 'nowrap'}}>
                {view_href &&
                    <Link to={view_href(transfer.user_id, transfer.id)} className='btn btn-sm btn-outline-primary'>
                        <span className='oi oi-eye'/>
                    </Link>
                }
                <Link to={edit_href(transfer.user_id, transfer.id)} className={
                    classnames('btn', 'btn-sm', 'ml-2', {
                        'btn-outline-primary': !view_href,
                        'btn-outline-info': !!view_href,
                    })
                }>
                    {view_href ? <span className='oi oi-pencil'/> : 'Редактировать'}
                </Link>
                {onDeleteTransfer && role == "admin" && <a href='#' className='btn btn-sm btn-outline-danger ml-4'
                    onClick={(ev) => {
                        ev.preventDefault();
                        onDeleteTransfer(transfer.user_id, transfer.id);
                    }}>
                    <span className='oi oi-trash'/>
                </a>}
            </td>
        </tr>;
    });

    return <div className='mt-4'>
        <Table responsive hover>
            <thead>
                <tr>
                    {firstHeader && firstHeader()}
                    <th style={{width: '1px'}}>Дата&nbsp;достав.</th>
                    <th className='text-right'>Итог</th>
                    {/* <th style={{width: '1px', textAlign: 'center'}} title='Нал'><span className='oi oi-dollar'/></th>
                    <th className='text-right'>Долг</th> */}
                    <th style={{width: '1px', textAlign: 'center'}} title='Оплачено'><span className='oi oi-check'/></th>
                    <th style={{width: '1px', textAlign: 'center'}} title='Проверено'><span className='oi oi-lock-locked'/></th>
                    <th style={{width: '1px', textAlign: 'center'}} title='Сканы'><span className='oi oi-file'/></th>
                    <th>Грузополучатель</th>
                    <th>Перевозчик</th>
                    <th>Маршрут</th>
                    <th>Номер авто / ФИО вод-ля</th>
                    <th>Действия</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    </div>
};

export const TransfersList = connect(
    (state, {user_id, transfer_id}) => {
        return {
            user_id,
            role: state.login.role,
        }
    },

    {
        onPushUrl: push
    }
)(TransfersListImpl);


const sort_by_key = (items, key_func) =>
    items.slice().sort((a, b) => {
        const ka = key_func(a);
        const kb = key_func(b);
        return kb - ka;
    });

const PendingTransfersList = ({transfers, view_href, edit_href, onDeleteTransfer, firstHeader, firstCell}) => {
    const by_month = {};
    sort_by_key(transfers, when_transfer_may_be_paid).forEach(transfer => {
        const date = when_transfer_may_be_paid(transfer);
        const month_no = date.getFullYear() * 12 + date.getMonth();
        if (!by_month[month_no])
            by_month[month_no] = [];
        by_month[month_no].push(transfer);
    });

    const month_no_to_human = month_no =>
        `${month_names[month_no % 12]} ${parseInt(month_no/12, 10)}`;

    return <div className='mt-4'>{
        Object.keys(by_month).sort().map(month_no =>
            <React.Fragment key={month_no}>
                <h4>План на {month_no_to_human(month_no)}</h4>

                <p>
                    <b>{by_month[month_no].length}</b>
                    {' '}{plural(by_month[month_no].length, 'перевозка', 'перевозки', 'перевозок')}
                    {' '}на общую сумму
                    {' '}<b>{format_price(by_month[month_no].reduce((acc, transfer) => acc + transfer_result_if_paid_today(transfer.params), 0))}</b>
                </p>

                <TransfersList
                    transfers={by_month[month_no]}
                    view_href={view_href}
                    edit_href={edit_href}
                    onDeleteTransfer={onDeleteTransfer}
                    firstHeader={firstHeader}
                    firstCell={firstCell}
                />
            </React.Fragment>
        )
    }</div>;
};


const transfers_url = (date_from, date_to, done_filter, debt_filter, tab) =>
    `${iso_date_string(date_from)}--${iso_date_string(date_to)}--${done_filter}--${debt_filter}--${tab}`;


class TransfersPageImpl extends React.Component {
    constructor(props) {
        super(...arguments);

        this.setDateFrom = this.setDateFrom.bind(this);
        this.setDateTo = this.setDateTo.bind(this);
        this.setDoneFilter = this.setDoneFilter.bind(this);

        this.state = {
            search: ''
        };
    }

    redirect({date_from, date_to, done_filter, debt_filter, tab}) {
        this.props.onRedirect(transfers_url(
            date_from !== undefined ? date_from : this.props.date_from,
            date_to !== undefined ? date_to : this.props.date_to,
            done_filter !== undefined ? done_filter : this.props.done_filter,
            debt_filter !== undefined ? debt_filter : this.props.debt_filter,
            tab !== undefined ? tab : this.props.tab,
        ));
    }

    filter_transfers() {
        const from = this.props.date_from ? date_from_string(this.props.date_from) : null;
        const to = this.props.date_to ? date_from_string(this.props.date_to) : null;
        const is_date_ok = transfer => {
            const base_date = base_transfer_date(transfer.params);
            const penalty_date = date_from_string(transfer.params.penalty_date);

            return date_in_optional_inclusive_range(base_date, from, to) || date_in_optional_inclusive_range(penalty_date, from, to);
        };

        const normalize_for_search = subject =>
            (subject || '').trim().toLowerCase().replace(/,/g, '.');

        const needle = normalize_for_search(this.state.search);
        const transfer_matches_search = transfer => {
            if (needle.length == 0) return true;
            if (normalize_for_search(transfer.params.title).indexOf(needle) !== -1) return true;
            if (normalize_for_search(transfer.params.basis).indexOf(needle) !== -1) return true;
            if (normalize_for_search(transfer.params.ttn_number).indexOf(needle) !== -1) return true;
            return false;
        }

        let transfers = this.props.transfers;
        if ([DONE_FILTER.ALL, DONE_FILTER.DONE].indexOf(this.props.done_filter) != -1)
            transfers = transfers.filter(is_date_ok);
        transfers = filter_by_done(transfers, this.props.done_filter)
        transfers = filter_by_debt(transfers, this.props.debt_filter);
        transfers = transfers.filter(transfer_matches_search);
        return transfers;
    }

    setDateFrom(ev) {
        const date_from = date_from_string(ev.target.value);
        this.redirect({date_from});
        this.raiseOnQueryChanged({date_from});
    }

    setDateTo(ev) {
        const date_to = date_from_string(ev.target.value);
        this.redirect({date_to});
        this.raiseOnQueryChanged({date_to});
    }

    setDoneFilter(done_filter) {
        this.redirect({done_filter});
        this.raiseOnQueryChanged({done_filter});
    }

    raiseOnQueryChanged({done_filter, date_from, date_to}) {
        if (!this.props.onQueryChanged)
            return;
        this.props.onQueryChanged(
            done_filter === undefined ? this.props.done_filter : done_filter,
            date_from === undefined ? this.props.date_from : date_from,
            date_to === undefined ? this.props.date_to : date_to
        );
    }

    render() {
        const transfers = this.filter_transfers();

        const total = transfers.reduce((acc, transfer) => {
            let total = 0;
            if (is_complete_transfer(transfer))
                total = transfer_result_in_period(transfer.params, this.props.date_from, this.props.date_to);
            else
                total = transfer_result_if_paid_today(transfer.params);
            return acc + (isNaN(total) ? 0 : total);
        }, 0);


        const form = <Row className='mt-2 mb-3'>
            <Col sm={4}>
                <BaseField label='Показывать' type='select' value={this.props.done_filter} onChange={this.setDoneFilter}>
                    <option value={DONE_FILTER.DONE}>Завершённые</option>
                    <option value={DONE_FILTER.NOT_PAID}>Неоплаченные</option>
                    {/*<option value={DONE_FILTER.NOT_SHIPPED}>Неотгруженные</option>
					<option value={DONE_FILTER.EXPIRED_DEBT}>С просроченным долгом</option>*/}
                    <option value={DONE_FILTER.ALL}>Все</option>
                </BaseField>
            </Col>
            {[DONE_FILTER.DONE, DONE_FILTER.ALL].indexOf(this.props.done_filter) != -1 && <Col sm={4}>
                <FormGroup>
                    <Label className='mr-2'>Дата:</Label>
                    <Form inline>
                    <Input className='mr-2' type='date' value={iso_date_string(this.props.date_from) || ''}
                        onChange={this.setDateFrom}/>
                    —
                    <Input className='ml-2' type='date' value={iso_date_string(this.props.date_to) || ''}
                        onChange={this.setDateTo}/>
                    </Form>
                </FormGroup>
            </Col>}
            {[DONE_FILTER.NOT_PAID].indexOf(this.props.done_filter) != -1 && <Col sm={4}>
                <BaseField label='Долг' type='select' value={this.props.debt_filter} onChange={value => this.redirect({debt_filter: value})}>
                    <option value={DEBT_FILTER.ALL}>Все</option>
                    <option value={DEBT_FILTER.NONZERO_DEBT}>С ненулевым долгом</option>
                </BaseField>
            </Col>}
            <Col sm={4}>
                <TextInput label='Поиск по Грузополучателю, Перевозчику, № Авто/ФИО вод-ля' value={this.state.search} onChange={value => this.setState({search: value})}/>
            </Col>
        </Row>;

        
        let content = null;
        if (this.props.loading)
            content = <p className="text-muted">Загрузка...</p>;

        else if (this.props.fail)
            content = <p className="text-danger">Ошибка загрузки</p>;

        else
            content = <React.Fragment>
                <Row>
                    <Col sm={5}>
                        <p>Итого: <strong>{transfers.length}</strong>{' '}
                        {plural(transfers.length, 'перевозка', 'перевозки', 'перевозок')}{' '}
                        на общую сумму <strong>{format_price(total)}</strong></p>
                    </Col>
                </Row>
                {[DONE_FILTER.NOT_PAID].indexOf(this.props.done_filter) != -1  ?
                    <PendingTransfersList transfers={transfers}
                        view_href={this.props.view_href}
                        edit_href={this.props.edit_href}
                        onDeleteTransfer={this.props.onDeleteTransfer}
                        firstHeader={this.props.firstHeader}
                        firstCell={this.props.firstCell}/>
                    :
                    <React.Fragment>
                        <Nav tabs>
                            <NavItem>
                                <NavLink className={this.props.tab == 'all' ? 'active' : ''} onClick={() => this.redirect({tab: 'all'})} href='#'>
                                    Все перевозки
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.props.tab == 'by_week' ? 'active' : ''} onClick={() => this.redirect({tab: 'by_week'})} href='#'>
                                    По неделям
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.props.tab == 'by_month' ? 'active' : ''} onClick={() => this.redirect({tab: 'by_month'})} href='#'>
                                    По месяцам
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.props.tab}>
                            <TabPane tabId='all'>
                                <TransfersList transfers={transfers}
                                    period_start={this.props.date_from}
                                    period_end={this.props.date_to}
                                    view_href={this.props.view_href}
                                    edit_href={this.props.edit_href}
                                    onDeleteTransfer={this.props.onDeleteTransfer}
                                    firstHeader={this.props.firstHeader}
                                    firstCell={this.props.firstCell}/>
                            </TabPane>
                            <TabPane tabId='by_week'>
                                <TransfersByWeek transfers={transfers}/>
                            </TabPane>
                            <TabPane tabId='by_month'>
                                <TransfersByMonth transfers={transfers}/>
                            </TabPane>
                        </TabContent>
                    </React.Fragment>
                }
            </React.Fragment>;


        return <React.Fragment>
            {form}
            {content}
        </React.Fragment>;
    }
}

export const TransfersPage = connect(
    null,
    (dispatch) => ({
        onDeleteTransfer: (user_id, transfer_id) => dispatch(delete_transfer(user_id, transfer_id)),
    })
)(TransfersPageImpl);


class MyTransfersPageImpl extends React.Component {
    componentDidMount() {
        this.props.onLoadTransfers(this.props.user_id);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.loaded && !nextProps.loading)
            this.props.onLoadTransfers(nextProps.user_id);
    }

    render() {
        return <Page wide>
            <Row className='align-items-center'>
                <Col xs={7}><h1>Мои перевозки</h1></Col>
                <Col xs={5} className='text-right'>
                    <Link to='/new-transfer' className='btn btn-outline-success'>Добавить перевозку</Link>
                </Col>
            </Row>
            <TransfersPage
                {...this.props}
                edit_href={(user_id, transfer_id) => `/transfer/${transfer_id}/edit`}
				view_href={(user_id, transfer_id) => `/transfer/${transfer_id}/view`}
            />
        </Page>;
    }
}

export const MyTransfersPage = connect(
    (state) => ({
        user_id: state.login.user_id,
        ...(state.transfers.by_user[state.login.user_id] || by_user_initial)
    }),
    dispatch => ({
        onLoadTransfers: user_id => dispatch(load_transfers(user_id))
    })
)(MyTransfersPageImpl);


class OthersTransfersPageImpl extends React.Component {
    componentDidMount() {
        if (!this.props.username)
            this.props.onLoadUsers();

        this.props.onLoadTransfers(this.props.user_id);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.username)
            nextProps.onLoadUsers();

        if (!nextProps.loaded && !nextProps.loading)
            this.props.onLoadTransfers(nextProps.user_id);
    }


    render() {
		let back_href = "/";
		
		if (this.props.role == "accountant")
            back_href = "/logists";
        else
			back_href = "/";

        return <Page wide>
		    <Link to={back_href}>← к списку пользователей</Link>
            <Row className='align-items-center'>
                <Col xs={7}><h1>
                    Перевозки {this.props.username}
                </h1></Col>
                {this.props.role != "accountant" &&
					<Col xs={5} className='text-right'>
						<Link to={`/users/${this.props.user_id}/new-transfer`} className='btn btn-outline-success'>Добавить перевозку</Link>
					</Col>
				}
            </Row>
            <TransfersPage
                {...this.props}
				role={this.props.role}
                edit_href={(user_id, transfer_id) => `/users/${user_id}/transfer/${transfer_id}/edit`}
                view_href={(user_id, transfer_id) => `/users/${user_id}/transfer/${transfer_id}/view`}
            />
        </Page>;
    }
}

export const OthersTransfersPage = connect(
    (state, {user_id}) => {
        const user = (state.users.users || []).filter(user => user.id == user_id)[0];
        return {
            username: user && user.username,
			role: state.login.role,
            ...(state.transfers.by_user[user_id] || by_user_initial),
        }
    },
    dispatch => ({
        onLoadUsers: () => dispatch(load_users()),
        onLoadTransfers: user_id => dispatch(load_transfers(user_id))
    })
)(OthersTransfersPageImpl);


class AllTransfersPageImpl extends React.PureComponent {
    componentDidMount() {
        this.props.onLoadTransfers(this.props.done_filter, this.props.date_from, this.props.date_to);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.state.loaded && !nextProps.state.loading)
            this.props.onLoadTransfers(this.props.done_filter, nextProps.date_from, nextProps.date_to);
    }

    render() {
        return <Page wide>
            <Row className='align-items-center'>
                <Col><h1>Все перевозки:</h1></Col>
            </Row>
            <TransfersPage
                {...this.props.state}
                date_from={this.props.date_from}
                date_to={this.props.date_to}
                done_filter={this.props.done_filter}
                tab={this.props.tab}
                onRedirect={this.props.onRedirect}
                edit_href={(user_id, transfer_id) => `/users/${user_id}/transfer/${transfer_id}/edit`}
                view_href={(user_id, transfer_id) => `/users/${user_id}/transfer/${transfer_id}/view`}
                onQueryChanged={this.props.onLoadTransfers}
                firstHeader={() => <th>Менеджер</th>}
                firstCell={transfer => <td>{this.props.state.usernames[transfer.user_id]}</td>}
            />
        </Page>
    }
}

export const AllTransfersPage = connect(
    state => ({state: state.transfers.all_transfers}),
    {
        onLoadTransfers: load_all_transfers
    }
)(AllTransfersPageImpl);



class StatefulCalculator extends React.Component {
    constructor(props) {
        super(props);

        this.state = props.transfer || {
            params: {
                transfer_type: 'buy_transfer',
                payments: []
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.transfer != nextProps.transfer)
            this.setState(nextProps.transfer);
    }

    render() {
        return <Calculator
            params={this.state.params}
            role={this.props.role}
            onChangeField={(field, value) => this.setState({params: {...this.state.params, [field]: value}})}
            onChangeFields={setter => this.setState({params: {...this.state.params, ...setter}})}
            onAddPayment={() => this.setState({params: {...this.state.params, payments: [...this.state.params.payments, {sum: 0, date: ''}]}})}
            onRemovePayment={(number) => this.setState({params: {...this.state.params, payments: this.state.params.payments.filter((payment, i) => i != number)}})}
            onChangePaymentField={(number, field, value) => {
                this.setState({params: {
                    ...this.state.params,
                    payments: this.state.params.payments.map((payment, i) => i == number ? {...payment, [field]: value} : payment)
                }})
            }}
        />
    }
}


class EditOrNewTransferForm extends React.Component {
    constructor() {
        super(...arguments);

        this.state = {
            shown_errors: null
        };

        this.calculator = React.createRef();

        this.onSave = this.onSave.bind(this);
        this.closeErrors = this.closeErrors.bind(this);
    }

    onSave() {
        const errors = transfer_validation_errors(this.calculator.current.state.params);
        this.setState({shown_errors: errors});
        if (errors.length == 0)
            this.props.onSave(this.calculator.current.state.params);
    }

    closeErrors() { this.setState({shown_errors: null}); }

    buttons() {
        return <React.Fragment>
            <Button outline color='secondary' onClick={this.props.onCancel}>Отмена</Button>
            {' '}
            <Button outline color='primary' onClick={this.onSave} disabled={this.props.saving}>
                {this.props.fail ? 'Ошибка сохранения' : 'Сохранить'}
            </Button>
        </React.Fragment>
    }

    render() {
        return <Page>
            <Row className='align-items-center'>
                <Col sm={8}><h1>{this.props.title}</h1></Col>
                <Col sm={4} className="text-sm-right">{this.buttons()}</Col>
            </Row>
            <StatefulCalculator ref={this.calculator} transfer={this.props.transfer} role={this.props.role}/>
            <Row>
                <Col className="text-sm-right">{this.buttons()}</Col>
            </Row>

            <Modal isOpen={this.state.shown_errors && this.state.shown_errors.length > 0} toggle={this.closeErrors}>
                <ModalHeader toggle={this.closeErrors}>Форма содержит ошибки</ModalHeader>
                <ModalBody>
                    <ul>{(this.state.shown_errors || []).map((error, i) =>
                        <li key={i}>{error}</li>
                    )}</ul>
                </ModalBody>
                <ModalFooter>
                    <Button color='secondary' onClick={this.closeErrors}>Вернуться</Button>
                </ModalFooter>
            </Modal>
        </Page>;
    }
}


class TransferEditPageImpl extends React.Component {
    componentDidMount() {
        // if (!this.props.loaded && !this.props.loading)
            this.props.onLoadTransfers(this.props.user_id);
    }

    render() {
        if (!this.props.loaded && this.props.loading)
            return <h2 className="text-muted">Загрузка...</h2>

        if (!this.props.loaded)
            return <h2 className="text-danger">Ошибка загрузки</h2>

        return <EditOrNewTransferForm
            title={<span>
                Редактирование перевозки {
                    this.props.transfer.params.locked && 
                    <span className='text-muted' style={{fontSize: '70%'}}><span className='oi oi-lock-locked'/></span>
                }
            </span>}
            transfer={this.props.transfer}
            role={this.props.role}
            onCancel={() => this.props.onPushUrl(this.props.cancel_href)}
            onSave={transfer => this.props.onSaveTransfer(this.props.user_id, this.props.transfer.id, transfer, this.props.ok_href)}
            saving={this.props.saving_transfer}
            fail={this.props.saving_transfer_fail}
        />;
    }
}

export const TransferEditPage = connect(
    (state, {user_id, transfer_id}) => {
        const by_user_state = state.transfers.by_user[user_id] || by_user_initial;
        return {
            user_id,
            role: state.login.role,
            loaded: by_user_state.loaded,
            loading: by_user_state.loading,
            transfer: by_user_state.transfers.filter(transfer => transfer.id == transfer_id)[0],
            saving_transfer: by_user_state.saving_transfer,
            saving_transfer_fail: by_user_state.saving_transfer_fail,
        }
    },

    {
        onLoadTransfers: load_transfers,
        onSaveTransfer: save_transfer,
        onPushUrl: push
    }
)(TransferEditPageImpl)

export const MyTransferEditPage = connect(
    (state) => ({
        user_id: state.login.user_id,
    })
)(TransferEditPage);



class TransferViewPageImpl extends React.Component {
    componentDidMount() {
        this.props.onLoadTransfers(this.props.user_id);
    }

    buttons() {
        return <Link to={this.props.cancel_href} className='btn btn-outline-secondary'>Назад</Link>;
    }
    
    render() {
        if (!this.props.loaded && this.props.loading)
            return <h2 className="text-muted">Загрузка...</h2>

        if (!this.props.loaded)
            return <h2 className="text-danger">Ошибка загрузки</h2>

        return <Page>
            <Row className='align-items-center'>
                <Col sm={8}><h1>Просмотр перевозки</h1></Col>
                <Col sm={4} className="text-sm-right">{this.buttons()}</Col>
            </Row>
            <Calculator params={this.props.transfer.params} readOnly/>
            <Row>
                <Col className="text-sm-right">{this.buttons()}</Col>
            </Row>
        </Page>;
    }
}

export const TransferViewPage = connect(
    (state, {user_id, transfer_id}) => {
        const by_user_state = state.transfers.by_user[user_id] || by_user_initial;
        return {
            user_id,
            loaded: by_user_state.loaded,
            loading: by_user_state.loading,
            transfer: by_user_state.transfers.filter(transfer => transfer.id == transfer_id)[0],
        }
    },

    (dispatch) => ({
        onLoadTransfers: (user_id) => dispatch(load_transfers(user_id)),
    })
)(TransferViewPageImpl);


export const MyTransferViewPage = connect(
    (state) => ({
        user_id: state.login.user_id,
    })
)(TransferViewPage);



const NewTransferPageImpl = (props) => <EditOrNewTransferForm
    title='Новая перевозка'
    transfer={undefined}
    role={props.role}
    onCancel={() => props.onPushUrl(props.cancel_href)}
    onSave={transfer => props.onSaveNewTransfer(props.user_id, transfer, props.ok_href)}
    saving={props.adding_transfer}
    fail={props.adding_transfer_fail}
/>;

export const NewTransferPage = connect(
    (state, {user_id}) => {
        const by_user_state = state.transfers.by_user[user_id] || by_user_initial;
        return {
            role: state.login.role,
            adding_transfer: by_user_state.adding_transfer,
            adding_transfer_fail: by_user_state.adding_transfer_fail,
        }
    },

    {
        onSaveNewTransfer: save_new_transfer,
        onPushUrl: push
    }
)(NewTransferPageImpl);

export const MyNewTransferPage = connect(
    (state) => ({
        user_id: state.login.user_id,
    })
)(NewTransferPage);



const group_by = (dt2key, key2dates, transfers) => {
    const per_period = {};
    transfers.forEach(transfer => {
        // if (!transfer.params.date)
        //     return;
        const base_date = base_transfer_date(transfer.params);
        const penalty_date = date_from_string(transfer.params.penalty_date);

        let period_key, group;

        if (base_date) {
            period_key = dt2key(date_from_string(base_date));
            group = per_period[period_key] = per_period[period_key] || [];
            group.push(transfer);
        }

        if (penalty_date) {
            period_key = dt2key(date_from_string(penalty_date));
            group = per_period[period_key] = per_period[period_key] || [];
            group.push(transfer);
        }

    });
    return Object.keys(per_period).sort().map(k => parseInt(k)).map(period_key => ({
        transfers: per_period[period_key],
        ...key2dates(period_key)
    }));
};

const group_by_week = (transfers) => {
    const week_calc_base = new Date(2015, 0, 5, 0, 0, 0).getTime();
    const day = 24*60*60e3;
    const week = 7*day;
    const get_week_no = dt => parseInt((new Date(dt).getTime() - week_calc_base) / week);
    const week_no_to_dates = (week_no) => ({
        from: new Date(week_no * week + week_calc_base),
        to: new Date((week_no+1) * week - day + week_calc_base),
    });

    return group_by(get_week_no, week_no_to_dates, transfers);
};

const group_by_month = (transfers) => {
    const get_month_no = dt => dt.getFullYear() * 12 + dt.getMonth();
    const month_no_to_dates = (month_no) => {
        const year = parseInt(month_no / 12);
        const month = month_no % 12;
        return {
            month_no,
            from: new Date(year, month, 1),
            to: new Date(year, month+1, 0),
        };
    };
    return group_by(get_month_no, month_no_to_dates, transfers);
};


const GroupedTransfersList = ({grouping_func, transfers}) => {
    const groups = grouping_func(transfers);
    const groups_with_sums = groups.slice().reverse().map(group => ({
        ...group,
        sum: group.transfers.reduce((acc, transfer) => {
            const total = transfer_result_in_period(transfer.params, group.from, group.to);
            return acc + (isNaN(total) ? 0 : total);
        }, 0)
    }));
    const rows = groups_with_sums.map((group, i) => {
        const sum = group.sum;
        const prev_sum = groups_with_sums[i+1] && groups_with_sums[i+1].sum;
        let delta_percent = parseInt((sum - prev_sum) / prev_sum * 100);
        let delta_percent_str = null;
        if (!isNaN(delta_percent))
            // delta_percent_str = `${delta_percent >= 0 ? '+' : '–'}${Math.abs(delta_percent)}%`;
            delta_percent_str = <React.Fragment>
                <span className={delta_percent >= 0 ? 'text-success' : 'text-danger'}>
                    {`${delta_percent >= 0 ? '+' : '–'}${Math.abs(delta_percent)}%`}
                </span>
            </React.Fragment>;
        return <tr key={i}>
            <td>{group.from.toLocaleDateString()} — {group.to.toLocaleDateString()}</td>
            <td className='text-right'>{format_price(sum)}</td>
            <td>{delta_percent_str}</td>
        </tr>
    });


    return <Table className='mt-4' hover>
        <thead>
            <tr>
                <th>Период</th>
                <th className='text-right'>Общая сумма</th>
                <th>Изменение к прошлому периоду</th>
            </tr>
        </thead>
        <tbody>{rows}</tbody>
    </Table>
};

const TransfersByWeek = (props) => <GroupedTransfersList grouping_func={group_by_week} {...props}/>
const TransfersByMonth = (props) => <GroupedTransfersList grouping_func={group_by_month} {...props}/>
